// src/components/CartOffcanvas.js
import React, { useEffect, useState } from 'react';
import { Offcanvas, Button,Row,Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons';
import "../styles/CartOffCanvas.css";
import { Link,useNavigate,useLocation} from 'react-router-dom';

function CartOffcanvas({ show, onClose }) {
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    setCartItems(storedCart);
  console.log(storedCart)
  }, [show]);

  const updateCart = (updatedCart) => {
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
    window.dispatchEvent(new Event('cartUpdated'));
  };

  const handleQuantityChange = (index, delta) => {
    const updatedCart = [...cartItems];
    updatedCart[index].quantity += delta;

    if (updatedCart[index].quantity <= 0) {
      updatedCart.splice(index, 1);
    }

    updateCart(updatedCart);
  };

  const handleRemove = (index) => {
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    updateCart(updatedCart);
  };
  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + item.variation.price * item.quantity, 0);
  };

  const handleCheckout = () => {
    onClose(); // close the offcanvas
    if (location.pathname === '/checkout') {
      // force reload the component (update state or trigger effect)
      navigate('/temp', { replace: true }); // quick redirect hack
      setTimeout(() => navigate('/checkout'), 10);
    } else {
      navigate('/checkout');
    }
  };

  return (
    <Offcanvas className="offcanvas-header-cart" show={show} onHide={onClose} placement="end">
      <Offcanvas.Header >
        <Offcanvas.Title>Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
       
        {cartItems.length === 0 ? (
            <div className="empty-cart" >
                <img src='/emptycart.png' alt="empty cart" style={{width:'70%',height:'auto'}}/><br/>
                <Button  className='check-out-btn2' onClick={() => window.location.href = '/shop'}>
                    Go to Shop
                </Button>
            </div>
        ) : (
        <>
            <div className="cart-body-upper">
            <ul className="list-unstyled">
                {cartItems.map((item, index) => (
                <li key={index} className="mb-3 border-bottom pb-2 d-flex align-items-start">
                    <img
                    src={item.image || 'https://via.placeholder.com/60'}
                    alt={item.name}
                    style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '10px' }}
                    />
                    <div className="flex-grow-1">
                        <Row>
                            <Col md={8} lg={8} xl={8} sm={8} xs={8}> 
                            
                            <div style={{fontSize:'13px'}}><strong>{item.title}</strong></div>
                            {item.variation && (
                            <div style={{fontSize:'12px'}}>
                              <div>Variation: {item.variation.unitValue}{item.variation.unitType} </div>
                              <div>
                                
                              <del className="text-muted">
                                        ₹{(parseFloat(item.variation.price) * 1.1).toFixed(2)}
                                      </del>{" "}
                                
                                <span style={{fontSize:'12px'}}><strong className="ms-2" >₹{item.variation.price}</strong> <strong>Total: ₹{item.variation.price * item.quantity}</strong></span>
                              </div>
                            </div>
                          )}
                          <div></div>

                            
                            </Col>
                            <Col md={4} lg={4} xl={4} sm={4} xs={4} className='d-flex flex-column align-items-end justify-content-end'>
                                <div className="quantity-selector-cartmodal mt-2">
                                    <Button variant="outline-secondary" onClick={() => handleQuantityChange(index, -1)}>
                                        <FontAwesomeIcon icon={faMinus} />
                                    </Button>
                                    <span className="quantity-cart">{item.quantity}</span>
                                    <Button variant="outline-secondary" onClick={() => handleQuantityChange(index, 1)}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </Button>
                                </div>
                                <Button variant="outline-danger" size="sm" className="mt-2 cart-can" onClick={() => handleRemove(index)}>
                                <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </Col>
                        </Row>
                
                    
                    
                    </div>
                </li>
                ))}
                </ul>
            </div>
            <div className='cart-body-lower border-top pt-3'>
            <div className="d-flex justify-content-between mb-3">
                <strong>Total:</strong>
                <span>₹{getTotalPrice()}</span>
            </div>
            <Button onClick={handleCheckout} className="w-100 check-out-btn m-1">Proceed to Checkout</Button>
            <Button variant="primary" className="w-100 check-out-btn2 m-1" onClick={onClose}>Continue shopping</Button>
            </div>

          </>
        )}
       
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default CartOffcanvas;
